import { Avatar, Box, Typography } from "@mui/material";
import move9jaLogo from "../assets/logo.svg";
import homeIcon from "../assets/home-icon.svg";
import walletIcon from "../assets/wallet.svg";
import messageIcon from "../assets/message.svg";
import affiliateIcon from "../assets/affiliateIcon.svg";
import settings from "../assets/settings.svg";
import ads from "../assets/ads.svg";
import promo from "../assets/promo.svg";
import { Logout } from "@mui/icons-material";
import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import profile from "../assets/profile.jpg";

// Each page renders its own layout, so the sidebar remounts on navigation.
// Keep its scroll position across remounts so it doesn't jump to the top.
let savedScrollTop = 0;

const NextSideBar = () => {
  const navigate = useNavigate();
  const scrollRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = savedScrollTop;
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    savedScrollTop = 0;
    navigate("/");
  };

  return (
    <>
      <Box
        ref={scrollRef}
        onScroll={(e) => {
          savedScrollTop = e.currentTarget.scrollTop;
        }}
        sx={{ overflowY: "scroll", scrollbarWidth: "none" }}
        width="100%"
        height="100vh"
        borderRight="1px solid #E4E7EC"
        pt="24px"
      >
        <Box height="603.26px">
          <Box p="8px 24px" mb="4px">
            <img src={move9jaLogo} alt="" width="162.75px" height="50.26px" />
          </Box>
          <Box
            p="0px 8px"
            mt="20px"
            mb="12px"
            pb="20px"
            borderBottom="1px solid #E4E7EC"
          >
            <SideBarCards title="Dashboard" icon={homeIcon} path="/dashboard" />

            <SideBarCards
              title="Affiliate Marketing"
              icon={affiliateIcon}
              path="/affiliate-marketing"
            />
            <SideBarCards
              title="Transactions"
              icon={walletIcon}
              path="/transactions"
            />
            <SideBarCards
              title="Finance"
              icon={walletIcon}
              path="/dashboard/finance"
            />
          </Box>

          <Box p="0px 8px" mb="12px" borderBottom="1px solid #E4E7EC">
            <Typography p="0px 16px 0px 12px" color="#98A2B3" fontSize={14}>
              Flights
            </Typography>
            {/* <SideBarCards
              title="Bookings"
              icon={walletIcon}
              path="/bookings/flight"
            /> */}

            <SideBarCards
              title="PNR Mail Update"
              icon={messageIcon}
              path="/dashboard/send-mail"
            />
            <SideBarCards
              title="Bookings"
              icon={walletIcon}
              path="/dashboard/manual-bookings"
            />
            <SideBarCards
              title="Popular Destinations"
              icon={promo}
              path="/dashboard/popular-destinations"
            />
            <SideBarCards
              title="Add Airport"
              icon={promo}
              path="/dashboard/airports"
            />
          </Box>

          <Box p="0px 8px" mb="12px" borderBottom="1px solid #E4E7EC">
            <Typography p="0px 16px 0px 12px" color="#98A2B3" fontSize={14}>
              Ride
            </Typography>
            <SideBarCards
              title="Bookings"
              icon={walletIcon}
              path="/bookings/ride"
            />

            {/* <SideBarCards title="Users" icon={messageIcon} path="/users" /> */}
            <SideBarCards
              title="State & Area Management"
              icon={messageIcon}
              path="/states"
            />
            <SideBarCards
              title="Vehicle Management"
              icon={messageIcon}
              path="/vehicles/add-vehicle"
            />
          </Box>

          <Box p="0px 8px" mb="12px" borderBottom="1px solid #E4E7EC">
            <Typography p="0px 16px 0px 12px" color="#98A2B3" fontSize={14}>
              Hotel
            </Typography>
            <SideBarCards
              title="Bookings"
              icon={walletIcon}
              path="/bookings/hotel"
            />
            <SideBarCards title="Tools" icon={settings} path="/hotel/tools" />
          </Box>

          <Box p="0px 8px" mb="12px" borderBottom="1px solid #E4E7EC">
            <Typography p="0px 16px 0px 12px" color="#98A2B3" fontSize={14}>
              eSIM
            </Typography>
            <SideBarCards
              title="Orders"
              icon={walletIcon}
              path="/esim/orders"
              matchChildren
            />
            <SideBarCards title="Tools" icon={settings} path="/esim/tools" />
          </Box>

          <Box p="0px 8px" mb="12px" borderBottom="1px solid #E4E7EC">
            <Typography p="0px 16px 0px 12px" color="#98A2B3" fontSize={14}>
              Pricing
            </Typography>
            <SideBarCards
              title="Exchange Rate"
              icon={walletIcon}
              path="/settings/exchange-rate"
            />
          </Box>

          <Box height="220px" />

          <Box p="0px 8px" mb="12px">
            <Box>
              <SideBarCards
                title="Addons"
                icon={promo}
                path="/addons" // Change onClick to path
              />
              <SideBarCards title="Settings" icon={settings} path="/settings" />
              {/* <SideBarCards title="Create Ad" icon={ads} path="/create-ad" /> */}
              <SideBarCards title="Coupon" icon={promo} path="/promo" />
            </Box>
          </Box>
          <Box
            p="12px 24px"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="12px"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <Avatar sx={{ height: 40, width: 40 }} src={profile} />
              <div>
                <Typography color="#101928" fontSize={14} fontWeight={600}>
                  David Fayemi
                </Typography>
                <Typography color="#475367" fontSize={14}>
                  David@rayna.ui
                </Typography>
              </div>
            </div>
            <Logout
              sx={{ height: 20, width: 20, cursor: "pointer" }}
              onClick={handleLogout}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default NextSideBar;

const SideBarCards = ({
  title,
  icon,
  path,
  onClick,
  matchChildren,
}: {
  title: string;
  icon: string;
  path?: string;
  onClick?: () => void;
  // Also highlight on sub-routes, e.g. /esim/orders/:orderRef.
  matchChildren?: boolean;
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive =
    !!path &&
    (pathname === path || (!!matchChildren && pathname.startsWith(`${path}/`)));

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (path) {
      navigate(path);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "12px 16px",
          gap: "12px",
          my: "4px",
          bgcolor: isActive ? "#E8FFF2" : "transparent",
          borderRadius: "4px",
          cursor: "pointer",
          "&:hover": { bgcolor: isActive ? "#E8FFF2" : "#F9FAFB" },
        }}
        onClick={handleClick}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            borderRadius: "4px",
          }}
        >
          <img src={icon} alt="" height={20} width={20} />
          <Typography fontSize={14}>{title}</Typography>
        </div>
      </Box>
    </Box>
  );
};
